import { FuseNavigation } from '@fuse/types';


export const navigation: FuseNavigation[] = [
    {
        id       : 'shop',
        title    : 'Produkty',
        type     : 'item',
        faIcon   : 'fas fa-list',
        url      : '/apps/shop'
    },
    {
        id       : 'orders',
        title    : 'Poptávky',
        type     : 'item',
        faIcon   : 'fas fa-list',
        url      : '/apps/orders'
    },
    {
        id       : 'admin',
        title    : 'Administrace',
        type     : 'group',
        icon     : 'apps',
        role     : 'admin',
        children : [
            {
                id       : 'sample',
                title    : 'Uživatelé',
                type     : 'item',
                faIcon   : 'fas fa-users',
                url      : '/apps/users'
            },
            {
                id       : 'products',
                title    : 'Produkty',
                type     : 'item',
                faIcon   : 'fas fa-list',
                url      : '/apps/products'
            },
            {
                id       : 'reclamation',
                title    : 'Reklamace',
                type     : 'item',
                faIcon   : 'fas fa-file-invoice-dollar',
                url      : '/apps/reclamation-list'
            }
        ]
    }
];
